export default function siteMenu() {
  let header, previousOverflow = '', background = [], desktop;
  const focusable = () => [...header.querySelectorAll('a[href],summary,button:not(:disabled),[tabindex="0"]')]
    .filter(element => element.getClientRects().length && !element.closest('[inert]'));
  return {
    open:false,
    init() {
      header = this.$el.closest('[data-site-header]');
      desktop = matchMedia('(min-width:1440px)');
      this.keyboard = event => {
        if (!this.open || document.querySelector('dialog[open]')) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
        if (event.key !== 'Tab') return;
        const targets = focusable(), first = targets[0], last = targets.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      };
      this.followLink = event => { if (this.open && event.target.closest('a[href]')) this.close(false); };
      this.resize = () => {
        if (!desktop.matches || !this.open) return;
        this.close(false);
        header.querySelector('.site-header-brand').focus({preventScroll:true});
      };
      header.addEventListener('keydown', this.keyboard);
      header.addEventListener('click', this.followLink);
      desktop.addEventListener('change', this.resize);
      this.sync();
    },
    sync() {
      const next = this.$refs.menu.open;
      if (next === this.open) return;
      this.open = next;
      if (!next) { this.restore(); return; }
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      header.classList.add('has-mobile-menu');
      header.setAttribute('role','dialog');
      header.setAttribute('aria-modal','true');
      header.setAttribute('aria-label','Site navigation');
      background = [...document.body.children]
        .filter(element => !element.contains(header) && !element.matches('script,style,link,dialog'))
        .map(element => ({element,inert:element.inert}));
      background.forEach(({element}) => { element.inert = true; });
    },
    restore() {
      header.classList.remove('has-mobile-menu');
      header.removeAttribute('role');
      header.removeAttribute('aria-modal');
      header.removeAttribute('aria-label');
      document.documentElement.style.overflow = previousOverflow;
      background.forEach(({element,inert}) => { element.inert = inert; });
      background = [];
    },
    close(returnFocus = true) {
      if (!this.open) return;
      this.$refs.menu.open = false;
      this.open = false;
      this.restore();
      if (returnFocus) this.$refs.trigger.focus({preventScroll:true});
    },
    destroy() {
      if (this.open) this.restore();
      header.removeEventListener('keydown', this.keyboard);
      header.removeEventListener('click', this.followLink);
      desktop.removeEventListener('change', this.resize);
    },
  };
}
